
import { TranslateModule } from '@keystone-angular/core';
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: true,
  imports: [TranslateModule],
  selector: 'app-print-notification',
  templateUrl: './print-notification.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./print-notification.component.scss']
})
export class PrintNotificationComponent implements OnInit {

    @Input() show: boolean;
    @Input() singleOrderLine: boolean;

    constructor() { }

    ngOnInit() { }

}
